import { render, staticRenderFns } from "./screening-content.vue?vue&type=template&id=edb8bddc&scoped=true"
import script from "./screening-content.vue?vue&type=script&lang=js"
export * from "./screening-content.vue?vue&type=script&lang=js"
import style0 from "./screening-content.vue?vue&type=style&index=0&id=edb8bddc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "edb8bddc",
  null
  
)

export default component.exports